import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { AiImageResource } from 'dy-frontend-http-repository/lib/modules/AiImage/resources';
import domain from './domain';
import { resetAiImages } from './events';

// Get list of AI Images
export const $aiImages = domain.createStore<CollectionResource<AiImageResource, {}> | null>(null).reset(resetAiImages);
